var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 46 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", { attrs: { width: "46", height: "46", fill: "white" } }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9061",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "46",
            height: "46",
          },
        },
        [
          _c("rect", {
            attrs: { width: "46", height: "46", rx: "6", fill: "#C4C4C4" },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9061)" } }, [
        _c("path", {
          attrs: {
            d: "M45.9992 0.0703125H0V45.9308H45.9992V0.0703125Z",
            fill: "#7FD2D5",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.0015 0.0703125H23.002V45.9308H46.0015V0.0703125Z",
            fill: "#37979B",
          },
        }),
        _c("path", {
          attrs: {
            d: "M22.9996 23H45.9992V45.9302H0V45.9302C0 33.2662 10.2973 23 22.9996 23Z",
            fill: "#4FB6BB",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }